import React, { memo } from "react";
import { Link } from "react-router-dom";
import DropdownNotification from "./dropdown/notification.jsx";
import DropdownLanguage from "./dropdown/language.jsx";
import DropdownProfile from "./dropdown/profile.jsx";
import SearchForm from "./search/form.jsx";
import DropdownMegaMenu from "./dropdown/mega.jsx";
import logo from "../../assets/images/logo-portrait@2x.png";
import { AppSettings } from "./../../config/app-settings.js";
import { useDispatch } from "react-redux";
import { KioskDashboardActions } from '../../_store';
import useKioskRestrictIntervalValidation from "../../hooks/useKioskRestrictIntervalValidation.jsx";

function Header() {
  // const validateKioskRestrictInterval = useKioskRestrictIntervalValidation();

  const handleInmateInbox = async () => {
    // validateKioskRestrictInterval(storedLoginDetails);
    // const podCode = storedLoginDetails?.PodCode;
    // const inmateID = storedloginResponse?.InmateID;
    // if (inmateID && podCode)
    //   dispatch(KioskDashboardActions.getLoadInmateMainMenu({ inmateID, podCode }));
  }


  return (
    <AppSettings.Consumer>
      {({
        toggleAppSidebarMobile,
        toggleAppSidebarEnd,
        toggleAppSidebarEndMobile,
        toggleAppTopMenuMobile,
        appHeaderLanguageBar,
        appHeaderMegaMenu,
        appHeaderInverse,
        appSidebarTwo,
        appTopMenu,
        appSidebarNone,
      }) => (
        <div
          id="header"
          className="app-header"
          data-bs-theme={appHeaderInverse ? "dark" : ""}
        >
          <div className="navbar-header p-2">
            {appSidebarTwo && (
              <button
                type="button"
                className="navbar-mobile-toggler"
                onClick={toggleAppSidebarEndMobile}
              >
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
            )}
            <Link onClick={() => { handleInmateInbox() }}
              to="/Dashboard"
              className=" text-decoration-none d-flex justify-content-between align-item-center w-100"
            >
              <img className='Sidebarlogo' src={logo} alt="small-logo" />
            </Link>

            {appHeaderMegaMenu && (
              <button
                type="button"
                className="navbar-mobile-toggler"
                data-bs-toggle="collapse"
                data-bs-target="#top-navbar"
              >
                <span className="fa-stack fa-lg text-inverse">
                  <i className="far fa-square fa-stack-2x"></i>
                  <i className="fa fa-cog fa-stack-1x"></i>
                </span>
              </button>
            )}
            {appTopMenu && !appSidebarNone && (
              <button
                type="button"
                className="navbar-mobile-toggler"
                onClick={toggleAppTopMenuMobile}
              >
                <span className="fa-stack fa-lg text-inverse">
                  <i className="far fa-square fa-stack-2x"></i>
                  <i className="fa fa-cog fa-stack-1x"></i>
                </span>
              </button>
            )}
            {appSidebarNone && appTopMenu && (
              <button
                type="button"
                className="navbar-mobile-toggler"
                onClick={toggleAppTopMenuMobile}
              >
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
            )}
            {!appSidebarNone && (
              <button
                type="button"
                className="navbar-mobile-toggler"
                onClick={toggleAppSidebarMobile}
              >
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
            )}
          </div>

          {appHeaderMegaMenu && <DropdownMegaMenu />}

          <div className="navbar-nav">
            {/* <SearchForm /> */}
            <DropdownNotification />

            {/* {appHeaderLanguageBar && <DropdownLanguage />} */}

            {/* <DropdownProfile /> */}

            {appSidebarTwo && (
              <div className="navbar-divider d-none d-md-block"></div>
            )}

            {appSidebarTwo && (
              <div className="navbar-item d-none d-md-block">
                <Link
                  to="/"
                  onClick={toggleAppSidebarEnd}
                  className="navbar-link icon"
                >
                  <i className="fa fa-th"></i>
                </Link>
              </div>
            )}
          </div>
        </div>
      )}
    </AppSettings.Consumer>
  );
}

export default memo(Header);
